export const CONSENT    = 'COOKIE_CONSENT/CONSENT';
